import React from 'react';
import classNames from 'classnames';
import {EmblaIcon} from '../emblaIcon/emblaIcon';
import {EmblaIconsType} from "../../emblaIcons";

type ReactContextMenuButtonProps = {
    label: string;
    icon: EmblaIconsType;
    onClick: () => void;
};

const ReactContextMenuButton = ({label, icon, onClick}: ReactContextMenuButtonProps) => (
    <button
        className={classNames("btn btn-svg border-0 shadow-none d-flex flex-space tooltip-hover-line align-items-center")}
        onClick={onClick}>
        <label style={{cursor: 'pointer'}}>{label}</label>
        <EmblaIcon
            iconName={icon}
            additionalClasses="small"/>
    </button>
);

export default ReactContextMenuButton;
